import type {
  Follow,
  PaginatedLoadingContextValue,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useEffect } from "react"

type SetAccountIdState = (
  accountId: Follow["following_account_id"],
  state: PaginatedLoadingContextValue,
) => void

export const defaultState: PaginatedLoadingContextValue = {
  error: null,
  loading: false,
  loaded: false,
  loadedAfter: null,
  loadedBefore: null,
}

interface UpdaterProps {
  accountId: Follow["following_account_id"];
  useContextHook: () => PaginatedLoadingContextValue;
  setState: SetAccountIdState;
}

/*
 * this component updates the AggregateLoadingContext with the loading state
 * for a particular account id
 */
export function AggregateLoadingContextUpdater(props: UpdaterProps) {
  const {
    accountId,
    useContextHook,
    setState,
  } = props

  const {
    error,
    loaded,
    loading,
    loadedAfter,
    loadedBefore,
  } = useContextHook()

  // updates the loading state for the accountId whenever it changes
  useEffect(
    () => {
      setState(
        accountId,
        {
          error,
          loaded,
          loading,
          loadedAfter,
          loadedBefore,
        },
      )
    },
    [
      accountId,
      setState,
      error,
      loaded,
      loading,
      loadedAfter,
      loadedBefore,
    ],
  )

  // resets to the default state on unmount
  useEffect(
    () => (
      () => {
        setState(
          accountId,
          defaultState,
        )
      }
    ),
    [
      setState,
      accountId,
    ],
  )

  return null
}
